import React, { useEffect, useState } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { IProduct, IProductsParams } from '../../../../types/products'
import AdminMenuItem from '../../components/admin-menu-item/AdminMenuItem'
import { ICategory } from '../../../../types/categories'
import { IProductGroup } from '../../../../types/app'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

type Props = {
  product: IProductGroup
  setProducts: React.Dispatch<React.SetStateAction<IProductGroup[]>>
  categories: ICategory[]
}
const c = 'products-page'

const DropComponent = (props: Props) => {
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true))

    return () => {
      cancelAnimationFrame(animation)
      setEnabled(false)
    }
  }, [])

  if (!enabled) {
    return null
  }

  return (
    <Droppable
      key={props.product.category_id}
      droppableId={`category-${props.product.category_id}`}
    >
      {(provided) => (
        <div
          className={`${c}__menu-items-container-products`}
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {props.product.items.map((item: IProduct, i: number) => {
            return (
              <Draggable key={item._id} draggableId={item._id} index={i}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    className={`${c}__draggable-item`}
                  >
                    <div
                      {...provided.dragHandleProps}
                      className={`${c}__drag-handle`}
                    >
                      <FontAwesomeIcon icon={faBars} />
                    </div>
                    <AdminMenuItem
                      key={i}
                      categories={props.categories}
                      setData={props.setProducts}
                      data={item}
                    />
                  </div>
                )}
              </Draggable>
            )
          })}
        </div>
      )}
    </Droppable>
  )
}

export default DropComponent
